<div class="noa__summary-wrapper">
    <!-- @if (!editMode()) { -->
    <div class="d-flex font-weight-bold align-items-center"
         style="gap:4px;">
        <!-- <div class="stop-number">
            {{ stopNumber() }}
        </div> -->
        <!-- @if (!isDeparture()) { -->
        <div class="font-size-16 flex-shrink-0 text-black">
            #{{ vesselStop().id }}
        </div>
        <!-- } -->
        <!-- <div class="font-size-16">
            {{ stopType() }}
        </div> -->
        <!-- @if(vesselStop()?.status) {
            <div class="approved-label">
                {{ vesselStop()?.status }}
            </div>
        } -->
        <!-- <button class="transparent-icon-button" (click)="onEdit()"><kendo-icon name="pencil"></kendo-icon></button> -->

    </div>

    <div class="d-flex justify-content-between">
        @if (startTimeDate()) {
            <div class="border border-radius-4">
                <div class="pt-1 px-2"
                     [ngClass]="startTimeIsValid() ? 'text-grey' : 'text-red'">
                    <b [ngClass]="startTimeIsValid() ? 'text-gray-dark' : 'text-red'"> {{ startTimeLabel() }}</b><br>
                    <span class="pr-1">{{ startTimeDate() }}</span>
                    <span>{{ startTimeTime() }}</span>
                </div>
            </div>
        }


        @if (endTimeDate()) {
            <div class="border border-radius-4 ml-1">
                <div class="pt-1 px-2"
                     [ngClass]="endTimeIsValid() ? 'text-grey' : 'text-red'">
                    <b [ngClass]="endTimeIsValid() ? 'text-gray-dark' : 'text-red'">{{ endTimeLabel() }}</b><br>
                    <span class="pr-1">{{ endTimeDate() }}</span>
                    <span>{{ endTimeTime() }}</span>
                </div>
            </div>
        }
    </div>
    <!-- }
    @else {
    <kendo-label [text]="locationLabel()" class="text-grey">
        <kendo-combobox [data]="locations()"
                        [value]="selectedLocation()" 
                        (valueChange)="selectedLocation.set($event)"
                        [valuePrimitive]="false" 
                        [valueField]="'id'" 
                        [textField]="'shortCode'" 
                        [clearButton]="false"
                        [fillMode]="'outline'" 
                        placeholder="Select location" 
                        [virtual]="true">
        </kendo-combobox>
    </kendo-label>

    <div class="row no-gutters mt-1" style="gap:12px;">
        <div class="col">
            <kendo-label [text]="startTimeLabel" class="text-grey">
                <kendo-datetimepicker [value]="startTime()" 
                                      [fillMode]="'outline'"
                                      (valueChange)="startTime.set($event)">
                </kendo-datetimepicker>
            </kendo-label>
        </div>
        @if (showEndTimePicker()) {
        <div class="col">
            <kendo-label [text]="endTimeLabel" class="text-grey">
                <kendo-datetimepicker [value]="endTime()" 
                                      [fillMode]="'outline'"
                                      (valueChange)="endTime.set($event)"
                                      placeholder="">
                </kendo-datetimepicker>
            </kendo-label>
        </div>
        }
    </div>
    <div class="mt-2">
        <button kendoButton class="bg-blue text-white w-100" (click)="onSave()">Save {{ stopType() }}</button>
    </div>
    } -->

</div>